import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
 link:{
    color: "rgb(0, 0, 255)",
    marginRight: 10,
 }
}));
